import React from 'react';
import {Space} from 'antd';
import styled from 'styled-components';
import Image from './Image';
const config = require('../data.json');

const icons = {
  facebook: 'social-facebook.svg',
  line: 'social-line.svg',
  threads: 'social-threads.svg',
  instagram: 'social-instagram.svg',
  // 白牌調整：lixiang 已移除 Shopee，但白牌基底保留——demo 的 socialMedia 仍有
  // shopee、且 static/images/social-shopee.svg 存在。少了這一行會組出
  // `/images/undefined` 而在首頁噴 404。
  shopee: 'social-shopee.svg',
};

export default function Links(props) {
  return (
    <Wrapper>
      <Space size={24}>
        {Object.keys(config.socialMedia)
          // 防呆：config 出現沒有對應圖示的平台時直接略過，
          // 而不是組出 `/images/undefined` 讓瀏覽器噴 404。
          .filter((key) => config.socialMedia[key].showOnFooter && icons[key])
          .map((key, idx) => (
            <Image
              key={idx}
              linkto={config.socialMedia[key].link}
              src={`/images/${icons[key]}`}
              style={{height: 32, width: 32}}
              alt={'social link - ' + config.socialMedia[key].name}
            />
          ))}
      </Space>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
